import React, { useEffect } from "react";
import { IModalProps } from "../../models/IModalProps";
import styles from "./Modal.module.css";

const Modal: React.FC<IModalProps> = (props: IModalProps) => {
	useEffect(() => {
		if (props.open) {
			window.onclick = (event) => {
				if (props.enableBackdrop) {
					const modal = document.getElementById(props.modalName);
					if (event.target === modal) {
						props.handleClose(props.modalName);
					}
				}
				return null;
			};
			window.onkeydown = (event) => {
				if (props.enableBackdrop && (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27)) {
					props.handleClose(props.modalName);
				}
				return null;
			};
		} else {
			window.onclick = null;
			window.onkeydown = null;
		}
	}, [props.open]);
	if (props.open) {
		return (
			<div key={props.modalName}>
				<div id={props.modalName} className={`${styles.dialog_parent} ${props.modal_parent_class} || ""`}>
					<div
						onClick={(e) => e.stopPropagation()}
						className={`dialog_content custom-scroller ${styles.dialog_content} ${props.modalClass || ""}`}
					>
						{props.children}
					</div>
				</div>

				<style>{`
                    .dialog_content{
                        background: ${props.modalStyles?.background ?? ""} ;
                        padding: ${props.modalStyles?.padding || "1.5rem"};
                        border-radius: ${props.modalStyles?.padding || "6px"} ;
                        width: ${props.modalStyles?.width || "25rem"};
                        min-width: ${props.modalStyles?.minWidth || "25rem"};
                        min-height: ${props.modalStyles?.minHeight || "12.5rem"};
                        max-width: ${props.modalStyles?.maxWidth || "37.5rem"};
                        max-height: ${props.modalStyles?.maxHeight};
                    }
                `}</style>
			</div>
		);
	}
	return <React.Fragment></React.Fragment>;
};
Modal.displayName = "Modal";
export default Modal;
